module.exports = __webpack_public_path__ + "img/graph2.4d523274.png";